import { ButtonComponent } from '../components/button/button.component';

interface AlertDialogPayload {
  icon: string;
  title: string;
  body: string[];
  actions: AlertDialogAction[];
  type: ALERT_DIALOG_TYPE;
  hideBackdrop?: boolean;
  isImageLoader?: boolean;
  imageSrc?: string;
  id?: string;
}

interface AlertDialogAction {
  displayText: string;
  key: string;
  type: typeof ButtonComponent.prototype.type;
  width: number;
  height: number;
}

enum ALERT_DIALOG_TYPE {
  DEFAULT = '',
  PRIMARY = 'primary',
  WARNING = 'warning',
  ERROR = 'error',
  SECONDARY = 'secondary'
}

export type { AlertDialogPayload, AlertDialogAction}
export { ALERT_DIALOG_TYPE };
